export class ForwarderFetchFedExPodByFacilityAndBookingNoRequest {
  facility: string | null;
  bookingNo: string | null;

  /**
   * @param facility - The facility code.
   * @param bookingNo - The booking number.
   */
  constructor();
  constructor(facility: string, bookingNo: string);
  constructor(facility?: string, bookingNo?: string) {
    this.facility = facility ?? null;
    this.bookingNo = bookingNo ?? null;
  }
}